import { useContext } from 'react';
import PropTypes from 'prop-types';

import { FormStepContext } from './FormStepContext';
import { stageOfProject } from '../../const/formConst';
import ButtonBack from '../form-buttons/ButtonBack';
import ButtonNext from '../form-buttons/ButtonNext';

const SecondStep = () => {
  const { currentStep, register, watch } = useContext(FormStepContext);
  const watchedStage = watch('stage');

  return (
    <>
      <div className="laForm__stage-item__sticky-header">
        <div className="laForm__stage-badge">Stage {currentStep.id}</div>
        <h2>
          Project <strong>stage</strong>
        </h2>
      </div>
      <div className="laForm__stage-item__wrapper">
        <fieldset className="row-fieldset">
          <legend>Let us know the current stage of the project.</legend>

          {stageOfProject.map((item) => (
            <div key={item.id} className="row-btn-group">
              <input
                type="checkbox"
                value={item.value}
                id={item.id}
                className="hidden-input"
                {...register('stage')}
              />
              <label htmlFor={item.id} className="ic-check">
                <span>{item.displayedValue}</span>
                <span>{item.description}</span>
              </label>
            </div>
          ))}
        </fieldset>
      </div>
      <div className="laForm__stage-item__btns">
        <ButtonBack stepId={currentStep.id} />
        <ButtonNext
          stepId={currentStep.id}
          isDisabled={!watchedStage || watchedStage.length === 0}
          buttonId={`${currentStep.id}-project-stage`}
        />
      </div>
    </>
  );
};

export default SecondStep;

SecondStep.propTypes = {
  currentStep: PropTypes.object,
};
